(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[980],{

/***/ 18774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/Button.js






const Button = (param)=>{
    let { Tag ="button" , type ="button" , styleType ="primary" , isTheme =false , isOutline =false , isOutline2 =false , isBlock =false , isPreLine =false , size , disabled =false , className , forwardRef , ...props } = param;
    const tabType = Tag !== "a" && {
        type
    };
    const themeClassName = !isTheme ? [
        !isOutline && !isOutline2 && "btn-".concat(styleType),
        isOutline && "btn-outline-".concat(styleType),
        isOutline2 && "btn-outline2-".concat(styleType)
    ] : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        ...tabType,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("btn", ...themeClassName, isBlock && "btn-block", isPreLine && "btn--pre-line", size && "btn-".concat(size), disabled && "disabled", className),
        ...props
    });
};
Button.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    type: (0,prop_types.oneOf)([
        "button",
        "submit",
        "reset"
    ]),
    styleType: (0,prop_types.oneOf)([
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "gray",
        "dark",
        "light",
        "info-light",
        "link",
        "copy",
        "input-group"
    ]),
    isTheme: prop_types.bool,
    isOutline: prop_types.bool,
    isOutline2: prop_types.bool,
    isBlock: prop_types.bool,
    isPreLine: prop_types.bool,
    disabled: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l"
    ]),
    className: prop_types.string,
    forwardRef: forward_ref/* default */.Z,
    focus: prop_types.bool
};
const ButtonLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        Tag: "a",
        ...props
    });
Button.Link = ButtonLink;
/* harmony default export */ var Button_Button = ((0,pureFC/* default */.Z)(Button));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js



/***/ }),

/***/ 38661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: true,
            px: true,
            children: children
        })
    });
};
FooterContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container.propTypes */ .W2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterContainer);


/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* binding */ FooterCopyrightLink; },
/* harmony export */   "rQ": function() { return /* binding */ FooterCopyrightText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);






const FooterCopyright = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
            mx: true,
            py: true,
            className: "text-center large-text-right",
            children: children
        })
    });
};
FooterCopyright.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightText = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
        className: "pt-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "footer__copyright_text",
            children: children
        })
    });
};
FooterCopyrightText.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightLink = (param)=>{
    let { href , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright_link", className),
        href: href,
        ...props,
        children: children
    });
};
FooterCopyrightLink.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const CompanyName = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "footer__copyright_company",
        children: children
    });
};
CompanyName.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
FooterCopyrightText.CompanyName = CompanyName;
/* harmony default export */ __webpack_exports__["ZP"] = (FooterCopyright);


/***/ }),

/***/ 52193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/index.js + 1 modules
var LogoLink = __webpack_require__(46096);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/LogoLink/index.js
// TODO: import to this file is deprecated!


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Logo.js





const FooterLogo = (param)=>/*#__PURE__*/ {
    let { logoPath , logoAlt =""  } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink/* default */.Z, {
            imgSrc: logoPath,
            alt: logoAlt
        })
    });
};
FooterLogo.propTypes = {
    logoPath: prop_types.string.isRequired,
    logoAlt: prop_types.string
};
/* harmony default export */ var Logo = (FooterLogo);


/***/ }),

/***/ 78682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterMainContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 9,
        ...props,
        children: children
    });
};
FooterMainContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterMainContainer);


/***/ }),

/***/ 53512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ FooterNavList; },
/* harmony export */   "Pw": function() { return /* binding */ FooterNavCol; },
/* harmony export */   "Q1": function() { return /* binding */ FooterNavListTitle; },
/* harmony export */   "iT": function() { return /* binding */ FooterNavListItem; },
/* harmony export */   "jO": function() { return /* binding */ FooterNavItemLink; },
/* harmony export */   "z4": function() { return /* binding */ FooterNavRow; }
/* harmony export */ });
/* unused harmony export FooterNavTitleLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67924);






const FooterNav = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("footer__nav", className),
        children: children
    });
};
FooterNav.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavRow = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        py: true,
        ...props,
        children: children
    });
};
FooterNavRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavCol = (param)=>/*#__PURE__*/ {
    let { sm =6 , md ="shrink" , lg ="shrink" , className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        sm: sm,
        md: md,
        lg: lg,
        className: className,
        children: children
    });
};
FooterNavCol.propTypes = {
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavList = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("footer__nav-list", className),
        children: children
    });
};
FooterNavList.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavListItem = (param)=>{
    let { enable =true , className ="" , children  } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("footer__nav-list_item", className),
        children: children
    }) : null;
};
FooterNavListItem.propTypes = {
    enable: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavItemLink = (param)=>{
    let { children , className ="" , href ="/" , isBold =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("footer__nav-list_item-link", isBold && "footer__nav-list_item-link--bold", className),
        ...props,
        children: children
    });
};
FooterNavItemLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    isBold: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
};
const FooterNavListTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer__nav-list_title",
        children: children
    });
};
FooterNavListTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterNavTitleLink = (param)=>{
    let { children , className ="" , href ="/" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("footer__nav-list_title-link", className),
        ...props,
        children: children
    });
};
FooterNavTitleLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
};
/* harmony default export */ __webpack_exports__["ZP"] = (FooterNav);


/***/ }),

/***/ 58287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterSideBarContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 3,
        ...props,
        children: children
    });
};
FooterSideBarContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSideBarContainer);


/***/ }),

/***/ 72025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FooterSocialItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61672);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const FooterSocial = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        className: "pt-0",
        children: children
    });
};
FooterSocial.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterSocialItemLink = (param)=>{
    let { name , href , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__social_item-link", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            name: name
        })
    });
};
FooterSocialItemLink.propTypes = {
    name: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSocial);


/***/ }),

/***/ 67478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X2": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_forward_ref__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52418);





const Container = (param)=>{
    let { Tag ="div" , isFluid =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("grid-container", isFluid && "fluid", className),
        children: children
    });
};
Container.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
const Row = (param)=>{
    let { forwardRef , Tag ="div" , position ="grid-x" , smCols , mdCols , lgCols , mx =false , px =false , my =false , py =false , center =false , middle =false , justify =false , bottom =false , start =false , spaceBetween =false , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)(position, mx && "grid-margin-x", px && "grid-padding-x", my && "grid-margin-y", py && "grid-padding-y", smCols && "small-up-".concat(smCols), mdCols && "medium-up-".concat(mdCols), lgCols && "large-up-".concat(lgCols), center && "align-center", middle && "align-middle", justify && "align-justify", bottom && "align-bottom", start && "align-start", spaceBetween && "align-space-between", className),
        ...props,
        children: children
    });
};
Row.propTypes = {
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    position: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "grid-x",
        "grid-y"
    ]),
    mx: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    smCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    middle: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    justify: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    spaceBetween: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node,
    start: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const Col = (param)=>{
    let { Tag ="div" , auto =false , shrink =false , sm ="" , md ="" , lg ="" , smOffset , mdOffset , lgOffset , smOrder , mdOrder , lgOrder , className ="" , center =false , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("cell", auto && "auto", shrink && "shrink", sm && "small-".concat(sm), md && "medium-".concat(md), lg && "large-".concat(lg), smOffset && "small-offset-".concat(smOffset), mdOffset && "medium-offset-".concat(mdOffset), lgOffset && "large-offset-".concat(lgOffset), smOrder && "small-order-".concat(smOrder), mdOrder && "medium-order-".concat(mdOrder), lgOrder && "large-order-".concat(lgOrder), center && "display--flex align-center", className),
        ...props,
        children: children
    });
};
Col.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    auto: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    shrink: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    center: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    mdOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    lgOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};


/***/ }),

/***/ 42866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading_Heading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/Heading.js







const Heading = (param)=>/*#__PURE__*/ {
    let { Tag ="h2" , size , color , weight , center , uppercase =false , className , italic , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("heading", size && "heading-".concat(size), weight && fontWeight/* default */.Z[weight], center && "text-center", italic && "text-italic", uppercase && "text-uppercase", color && "text-color-".concat(color), className),
        ...props
    });
};
Heading.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6"
        ]),
        prop_types.elementType
    ]),
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l",
        "xl",
        "xxl",
        "xxxl"
    ]),
    center: prop_types.bool,
    italic: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: (0,prop_types.oneOf)([
        ...color/* brandColors */.D2,
        ...color/* blackColors */.qr,
        ...color/* whiteColors */.cK,
        ...color/* commonColors */.Hk
    ]),
    className: prop_types.string
};
/* harmony default export */ var Heading_Heading = ((0,pureFC/* default */.Z)(Heading));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js



/***/ }),

/***/ 61672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Icon_Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/Icon.js






const iconPrefix = "wrapper";
const legacyNames = new Map([
    [
        "download",
        "arrow-to-bottom"
    ],
    [
        "cart",
        "shopping-cart"
    ],
    [
        "profile",
        "user-alt"
    ],
    [
        "arrow-long-left",
        "long-arrow-left"
    ],
    [
        "arrow-long-right",
        "long-arrow-right"
    ],
    [
        "arrow-left-2",
        "arrow-left"
    ],
    [
        "arrow-right-2",
        "arrow-right"
    ]
]);
const Icon = (param)=>/*#__PURE__*/ {
    let { name , size , className , Tag ="i" , color , animate =false , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("".concat(iconPrefix, "-icon"), "".concat(iconPrefix, "-icon-").concat(legacyNames.get(name) || name), size && "".concat(iconPrefix, "-icon--").concat(size), animate && "".concat(iconPrefix, "-icon--animate"), color && "text-color-".concat(color), className),
        ...props
    });
};
Icon.propTypes = {
    name: (0,prop_types.oneOf)([
        "angle-down",
        "angle-left",
        "angle-right",
        "angle-up",
        "mac",
        "arrow-left",
        "arrow-right",
        "arrow-to-bottom",
        "check",
        "chevron-down",
        "chevron-left",
        "chevron-right",
        "chevron-up",
        "clock",
        "copy",
        "debug",
        "long-arrow-left",
        "long-arrow-right",
        "play",
        "plus",
        "question-circle",
        "linux",
        "linux_rpm",
        "search",
        "shopping-cart",
        "sort",
        "times",
        "linux_deb",
        "user",
        "user-alt",
        "windows",
        "facebook-f",
        "twitter",
        "linkedin-in",
        "youtube",
        "facebook-square",
        "linkedin-square",
        "twitter-square",
        "youtube-alt",
        "dna",
        "book",
        "graduation-cap",
        "life-ring",
        "question",
        "video",
        "bullhorn",
        "file-star",
        "link-ext",
        "rocket-launch",
        "comments-alt"
    ]).isRequired,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l",
        "xl",
        "xxl",
        "xxxl",
        "xxxxl"
    ]),
    color: (0,prop_types.oneOf)([
        ...color/* brandColors */.D2,
        ...color/* blackColors */.qr,
        ...color/* whiteColors */.cK,
        "red",
        "green",
        "lime"
    ]),
    animate: prop_types.bool,
    className: prop_types.string,
    Tag: prop_types.elementType
};
/* harmony default export */ var Icon_Icon = ((0,pureFC/* default */.Z)(Icon));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js



/***/ }),

/***/ 10334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js + 1 modules
var AssetsProvider = __webpack_require__(84154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/Image.js





const Image = (param)=>{
    let { isBaseUrl =true , src , alt ="" , shadow =false , className ="" , ...props } = param;
    const baseUrl = isBaseUrl ? (0,react.useContext)(AssetsProvider/* default.context */.Z.context) : "";
    const altText = alt.trim();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: "".concat(baseUrl).concat(src),
        className: (0,classes/* classes */.S)("image", shadow && "image--shadow", className),
        alt: altText,
        ...props
    });
};
Image.propTypes = {
    isBaseUrl: prop_types.bool,
    src: prop_types.string.isRequired,
    className: prop_types.string,
    alt: prop_types.string,
    shadow: prop_types.bool
};
/* harmony default export */ var Image_Image = (Image);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js



/***/ }),

/***/ 25522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/Link.js







const Link = (param)=>/*#__PURE__*/ {
    let { Tag ="a" , external =false , className , inverted , size , weight , color , hoverColor , isBaseClassName =true , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)(isBaseClassName && "link", inverted && "link--inverted", external && "link--external", size && "text-".concat(size), weight && fontWeight/* default */.Z[weight], !inverted && color && "text-color-".concat(color), !inverted && hoverColor && "text-color-".concat(hoverColor, "--hover"), className),
        ...props
    });
};
Link.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    external: prop_types.bool,
    className: prop_types.string,
    inverted: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xxxl",
        "xxl",
        "xl",
        "l",
        "m",
        "s",
        "xs"
    ]),
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: (0,prop_types.oneOf)([
        ...color/* brandColors */.D2,
        ...color/* blackColors */.qr,
        ...color/* whiteColors */.cK,
        ...color/* commonColors */.Hk
    ]),
    hoverColor: (0,prop_types.oneOf)([
        ...color/* brandColors */.D2,
        ...color/* blackColors */.qr,
        ...color/* whiteColors */.cK,
        ...color/* commonColors */.Hk
    ]),
    isBaseClassName: prop_types.bool
};
const LinkButton = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
        Tag: "button",
        type: "button",
        ...props
    });
Link.Button = LinkButton;
/* harmony default export */ var Link_Link = ((0,pureFC/* default */.Z)(Link));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js



/***/ }),

/***/ 46096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoLink_LogoLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/LogoLink.js






const LogoLink = (param)=>/*#__PURE__*/ {
    let { href ="/" , external =true , imgSrc , alt ="" , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: href,
        external: external,
        isBaseClassName: false,
        className: (0,classes/* classes */.S)("logo-link", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: imgSrc,
            className: (0,classes/* classes */.S)("logo"),
            alt: alt
        })
    });
};
LogoLink.propTypes = {
    href: prop_types.string,
    external: prop_types.bool,
    imgSrc: prop_types.string.isRequired,
    alt: prop_types.string,
    className: prop_types.string
};
/* harmony default export */ var LogoLink_LogoLink = (LogoLink);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/index.js



/***/ }),

/***/ 88881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const NavbarItem = (param)=>{
    let { enable =true , secondary =false , className , ...props } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)(secondary && "secondary-nav__item", className),
        ...props
    }) : null;
};
NavbarItem.propTypes = {
    enable: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    secondary: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItem);


/***/ }),

/***/ 81453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);





const NavbarItemLink = (param)=>{
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , className , ...props } = param;
    const config = Tag === _Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z && {
        isBaseClassName: false
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...config,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("nav__item-link", className),
        ...props
    });
};
NavbarItemLink.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_4__.elementType
    ]),
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItemLink);


/***/ }),

/***/ 74229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paragraph_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/Paragraph.js







const Paragraph = (param)=>/*#__PURE__*/ {
    let { Tag ="p" , size , center , uppercase =false , color , className ="" , block =false , weight , italic , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)(size && "text-".concat(size), weight && fontWeight/* default */.Z[weight], center && "text-center", uppercase && "text-uppercase", color && "text-color-".concat(color), italic && "text-italic", block && "display--block", className),
        ...props
    });
};
Paragraph.propTypes = {
    Tag: prop_types.string,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l",
        "xl",
        "xxl",
        "xxxl"
    ]),
    italic: prop_types.bool,
    center: prop_types.bool,
    block: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: (0,prop_types.oneOf)([
        ...color/* brandColors */.D2,
        ...color/* blackColors */.qr,
        ...color/* whiteColors */.cK,
        ...color/* commonColors */.Hk
    ]),
    className: prop_types.string
};
/* harmony default export */ var Paragraph_Paragraph = ((0,pureFC/* default */.Z)(Paragraph));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js



/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Section_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/Section.js




const Section = (param)=>{
    let { className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,classes/* classes */.S)(className),
        ...props,
        children: children
    });
};
Section.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Section_Section = (Section);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js



/***/ }),

/***/ 5558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Navbar.js




const Navbar = (param)=>/*#__PURE__*/ {
    let { nav , type =null , className ="" , children , inverted  } = param;
    return (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("nav", nav && "".concat(nav, "-nav"), type && "nav-type-".concat(type), inverted && "nav--inverted", className),
        children: children
    });
};
Navbar.propTypes = {
    nav: (0,prop_types.oneOf)([
        "primary",
        "secondary"
    ]).isRequired,
    type: (0,prop_types.oneOf)([
        1
    ]),
    className: prop_types.string,
    children: prop_types.node,
    inverted: prop_types.bool
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/HeaderNavbar/index.js
// TODO: import to this file is deprecated!



/***/ }),

/***/ 11538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/Layout.js




const Header = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Header.propTypes = {
    children: prop_types.node.isRequired
};
const Body = (param)=>{
    let { children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "main",
            className: className,
            children: children
        })
    });
};
Body.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const Layout = (param)=>/*#__PURE__*/ {
    let { bgColor ="transparent" , children , isWrapper =false , className =""  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "body{background-color: ".concat(bgColor, "}")
            }),
            !isWrapper && !className ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classes/* classes */.S)(isWrapper && "layout-wrapper", className),
                children: children
            })
        ]
    });
};
Layout.propTypes = {
    children: prop_types.node.isRequired,
    isWrapper: prop_types.bool,
    bgColor: prop_types.string,
    className: prop_types.string
};
Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/Layout/index.js
// TODO: import to this file is deprecated!



/***/ }),

/***/ 50516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Link__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25522);
// TODO: import to this file is deprecated!



/***/ }),

/***/ 70174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/ToggleButton.js




const NavbarToggleButton = (param)=>/*#__PURE__*/ {
    let { classNames , isOpen =false , onClick  } = param;
    return (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0,classes/* classes */.S)("navbar__toggle", isOpen && "expanded", classNames),
        "data-toggle": "toggleButton",
        "data-target": "#navbar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            })
        ]
    });
};
NavbarToggleButton.propTypes = {
    classNames: prop_types.string,
    onClick: prop_types.func,
    isOpen: prop_types.bool
};
/* harmony default export */ var ToggleButton = (NavbarToggleButton);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Header.js






const Header = (param)=>{
    let { hero =false , isBorderBottomNone =false , className ="" , logo , children  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggle = ()=>setIsOpen(!isOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (0,classes/* classes */.S)("header", hero && "header--hero", isBorderBottomNone && "header--border-none", className),
        role: "banner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                className: "header__layout navbar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                        middle: true,
                        justify: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "navbar__header align-justify",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header__logo",
                                        children: logo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                                        onClick: toggle,
                                        isOpen: isOpen
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,classes/* classes */.S)("navbar__collapse", isOpen && "show"),
                                id: "navbar",
                                children: children
                            })
                        ]
                    })
                })
            })
        })
    });
};
Header.propTypes = {
    hero: prop_types.bool,
    isBorderBottomNone: prop_types.bool,
    // inverted: bool,
    logo: prop_types.element.isRequired,
    children: prop_types.node,
    className: prop_types.string
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/Header/index.js
// TODO: import to this file is deprecated!



/***/ }),

/***/ 81934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18774);
// TODO: import to this file is deprecated!



/***/ }),

/***/ 25198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Footer.js




const Footer = (param)=>{
    let { isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (0,classes/* classes */.S)("footer", isBorderNone && "border--none", className),
        children: children
    });
};
Footer.propTypes = {
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r2/Footer/index.js



/***/ }),

/***/ 67924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ classes; }
/* harmony export */ });
/* unused harmony export cn */
/* harmony import */ var _insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38733);
/* harmony import */ var _transduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19263);
/* harmony import */ var _predicates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53863);
/* eslint-disable prettier/prettier */ 


const trim = (value)=>value.trim();
const cn = (className)=>isString(className) ? trim(className) : "";
const join = function() {
    let separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return (text, str)=>text && str && "".concat(text).concat(separator).concat(str) || str || text;
};
const classes = function() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return classNames.reduce((0,_insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(join(" "), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX((0,_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isUnique */ .bT)()), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isNotEmpty */ .UE), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(trim), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)), "");
};


/***/ }),

/***/ 68657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ brandColors; },
/* harmony export */   "Hk": function() { return /* binding */ commonColors; },
/* harmony export */   "cK": function() { return /* binding */ whiteColors; },
/* harmony export */   "jh": function() { return /* binding */ bgColor4; },
/* harmony export */   "mE": function() { return /* binding */ bgColorWhite; },
/* harmony export */   "qr": function() { return /* binding */ blackColors; },
/* harmony export */   "vk": function() { return /* binding */ bgColorBlack2; }
/* harmony export */ });
/* unused harmony exports bgBrandGradient, bgColorNone, bgColorBlack, bgColorBlack85, bgColorBlack64, bgColorBlack60, bgColorBlack46, bgColorBlack40, bgColorBlack35, bgColorBlack20, bgColorBlack15, bgColorBlack10, bgColorBlack4, bgColorWhite80, bgColorWhite70, bgColorWhite60, bgColorWhite40, bgColorWhite35, bgColorWhite20, bgColorWhite15, bgColorWhite10, bgColorWhite4, bgColor1, bgColor114, bgColor110, bgColor105, bgColor1l, bgColor2, bgColor210, bgColor205, bgColor286, bgColor3, bgColor360, bgColor310, bgColor305, bgColor414, bgColor405, bgColor5, bgColor540, bgColor512, bgColor503, bgColor6, bgColorGreen, bgColorRed, bgColorLime, bgColorOrange, colorBlack, colorBlack85, colorBlack64, colorBlack60, colorBlack46, colorBlack40, colorBlack35, colorBlack20, colorBlack15, colorBlack10, colorBlack4, colorBlack2, colorWhite, colorWhite80, colorWhite70, colorWhite60, colorWhite40, colorWhite35, colorWhite20, colorWhite15, colorWhite10, colorWhite4, color1, color114, color110, color105, color1l, color2, color210, color205, color286, color3, color360, color310, color305, color4, color414, color405, color5, color540, color512, color503, colorGreen, colorRed, colorLime, colorOrange */
const bgTpl = (color)=>"bg-color-".concat(color);
const colorTpl = (color)=>"text-color-".concat(color);
const commonColorsSchema = {
    red: "red",
    green: "green",
    lime: "lime",
    orange: "orange"
};
const blackColorSchema = {
    100: "black",
    85: "black--85",
    64: "black--64",
    60: "black--60",
    46: "black--46",
    40: "black--40",
    35: "black--35",
    20: "black--20",
    15: "black--15",
    10: "black--10",
    4: "black--04",
    2: "black--02"
};
const whiteColorSchema = {
    100: "white",
    80: "white--80",
    70: "white--70",
    60: "white--60",
    40: "white--40",
    35: "white--35",
    20: "white--20",
    15: "white--15",
    10: "white--10",
    4: "white--04"
};
const brandColorSchema = {
    100: "1",
    114: "1--14",
    110: "1--10",
    105: "1--05",
    "1l": "1--light",
    200: "2",
    210: "2--10",
    205: "2--05",
    286: "2--86",
    300: "3",
    360: "3--60",
    310: "3--10",
    305: "3--05",
    400: "4",
    414: "4--14",
    405: "4--05",
    500: "5",
    540: "5--40",
    512: "5--12",
    503: "5--03",
    600: "6",
    "brand-gradient": "brand-gradient"
};
const blackColors = Object.values(blackColorSchema);
const whiteColors = Object.values(whiteColorSchema);
const brandColors = Object.values(brandColorSchema);
const commonColors = Object.values(commonColorsSchema);
const bgBrandGradient = bgTpl(brandColorSchema["brand-gradient"]);
const bgColorNone = "bg--transparent";
const bgColorBlack = bgTpl(blackColorSchema["100"]);
const bgColorBlack85 = bgTpl(blackColorSchema["85"]);
const bgColorBlack64 = bgTpl(blackColorSchema["64"]);
const bgColorBlack60 = bgTpl(blackColorSchema["60"]);
const bgColorBlack46 = bgTpl(blackColorSchema["46"]);
const bgColorBlack40 = bgTpl(blackColorSchema["40"]);
const bgColorBlack35 = bgTpl(blackColorSchema["35"]);
const bgColorBlack20 = bgTpl(blackColorSchema["20"]);
const bgColorBlack15 = bgTpl(blackColorSchema["15"]);
const bgColorBlack10 = bgTpl(blackColorSchema["10"]);
const bgColorBlack4 = bgTpl(blackColorSchema["4"]);
const bgColorBlack2 = bgTpl(blackColorSchema["2"]);
const bgColorWhite = bgTpl(whiteColorSchema["100"]);
const bgColorWhite80 = bgTpl(whiteColorSchema["80"]);
const bgColorWhite70 = bgTpl(whiteColorSchema["70"]);
const bgColorWhite60 = bgTpl(whiteColorSchema["60"]);
const bgColorWhite40 = bgTpl(whiteColorSchema["40"]);
const bgColorWhite35 = bgTpl(whiteColorSchema["35"]);
const bgColorWhite20 = bgTpl(whiteColorSchema["20"]);
const bgColorWhite15 = bgTpl(whiteColorSchema["15"]);
const bgColorWhite10 = bgTpl(whiteColorSchema["10"]);
const bgColorWhite4 = bgTpl(whiteColorSchema["4"]);
const bgColor1 = bgTpl(brandColorSchema["100"]);
const bgColor114 = bgTpl(brandColorSchema["114"]);
const bgColor110 = bgTpl(brandColorSchema["110"]);
const bgColor105 = bgTpl(brandColorSchema["105"]);
const bgColor1l = bgTpl(brandColorSchema["1l"]);
const bgColor2 = bgTpl(brandColorSchema["200"]);
const bgColor210 = bgTpl(brandColorSchema["210"]);
const bgColor205 = bgTpl(brandColorSchema["205"]);
const bgColor286 = bgTpl(brandColorSchema["286"]);
const bgColor3 = bgTpl(brandColorSchema["300"]);
const bgColor360 = bgTpl(brandColorSchema["360"]);
const bgColor310 = bgTpl(brandColorSchema["310"]);
const bgColor305 = bgTpl(brandColorSchema["305"]);
const bgColor4 = bgTpl(brandColorSchema["400"]);
const bgColor414 = bgTpl(brandColorSchema["414"]);
const bgColor405 = bgTpl(brandColorSchema["405"]);
const bgColor5 = bgTpl(brandColorSchema["500"]);
const bgColor540 = bgTpl(brandColorSchema["540"]);
const bgColor512 = bgTpl(brandColorSchema["512"]);
const bgColor503 = bgTpl(brandColorSchema["503"]);
const bgColor6 = bgTpl(brandColorSchema["600"]);
const bgColorGreen = bgTpl(commonColorsSchema.green);
const bgColorRed = bgTpl(commonColorsSchema.red);
const bgColorLime = bgTpl(commonColorsSchema.lime);
const bgColorOrange = bgTpl(commonColorsSchema.orange);
const colorBlack = colorTpl(blackColorSchema["100"]);
const colorBlack85 = colorTpl(blackColorSchema["85"]);
const colorBlack64 = colorTpl(blackColorSchema["64"]);
const colorBlack60 = colorTpl(blackColorSchema["60"]);
const colorBlack46 = colorTpl(blackColorSchema["46"]);
const colorBlack40 = colorTpl(blackColorSchema["40"]);
const colorBlack35 = colorTpl(blackColorSchema["35"]);
const colorBlack20 = colorTpl(blackColorSchema["20"]);
const colorBlack15 = colorTpl(blackColorSchema["15"]);
const colorBlack10 = colorTpl(blackColorSchema["10"]);
const colorBlack4 = colorTpl(blackColorSchema["4"]);
const colorBlack2 = colorTpl(blackColorSchema["2"]);
const colorWhite = colorTpl(whiteColorSchema["100"]);
const colorWhite80 = colorTpl(whiteColorSchema["80"]);
const colorWhite70 = colorTpl(whiteColorSchema["70"]);
const colorWhite60 = colorTpl(whiteColorSchema["60"]);
const colorWhite40 = colorTpl(whiteColorSchema["40"]);
const colorWhite35 = colorTpl(whiteColorSchema["35"]);
const colorWhite20 = colorTpl(whiteColorSchema["20"]);
const colorWhite15 = colorTpl(whiteColorSchema["15"]);
const colorWhite10 = colorTpl(whiteColorSchema["10"]);
const colorWhite4 = colorTpl(whiteColorSchema["4"]);
const color1 = colorTpl(brandColorSchema["100"]);
const color114 = colorTpl(brandColorSchema["114"]);
const color110 = colorTpl(brandColorSchema["110"]);
const color105 = colorTpl(brandColorSchema["105"]);
const color1l = colorTpl(brandColorSchema["1l"]);
const color2 = colorTpl(brandColorSchema["200"]);
const color210 = colorTpl(brandColorSchema["210"]);
const color205 = colorTpl(brandColorSchema["205"]);
const color286 = colorTpl(brandColorSchema["286"]);
const color3 = colorTpl(brandColorSchema["300"]);
const color360 = colorTpl(brandColorSchema["360"]);
const color310 = colorTpl(brandColorSchema["310"]);
const color305 = colorTpl(brandColorSchema["305"]);
const color4 = colorTpl(brandColorSchema["400"]);
const color414 = colorTpl(brandColorSchema["414"]);
const color405 = colorTpl(brandColorSchema["405"]);
const color5 = colorTpl(brandColorSchema["500"]);
const color540 = colorTpl(brandColorSchema["540"]);
const color512 = colorTpl(brandColorSchema["512"]);
const color503 = colorTpl(brandColorSchema["503"]);
const colorGreen = bgTpl(commonColorsSchema.green);
const colorRed = bgTpl(commonColorsSchema.red);
const colorLime = bgTpl(commonColorsSchema.lime);
const colorOrange = bgTpl(commonColorsSchema.orange);


/***/ }),

/***/ 36336:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    thin: "text-weight--thin",
    "ultra-light": "text-weight--ultra-light",
    light: "text-weight--light",
    normal: "text-weight--normal",
    medium: "text-weight--medium",
    semi: "text-weight--semi",
    bold: "text-weight--bold",
    "bold-extra": "text-weight--bold-extra",
    "bold-heavy": "text-weight--bold-heavy"
});


/***/ }),

/***/ 52418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

// eslint-disable-next-line react/forbid-prop-types
const forwardRef = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOfType)([
    prop_types__WEBPACK_IMPORTED_MODULE_0__.func,
    (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        current: prop_types__WEBPACK_IMPORTED_MODULE_0__.object
    })
]);
/* harmony default export */ __webpack_exports__["Z"] = (forwardRef);


/***/ }),

/***/ 53863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "UE": function() { return /* binding */ isNotEmpty; },
/* harmony export */   "bT": function() { return /* binding */ isUnique; }
/* harmony export */ });
const isString = (value)=>typeof value === "string";
const isUnique = ()=>{
    const processed = new Set();
    return (value)=>{
        if (processed.has(value)) return false;
        processed.add(value);
        return true;
    };
};
const isNotEmpty = (value)=>Boolean(value);


/***/ }),

/***/ 19738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const pureFC = (Component)=>Object.assign(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(Component), Component);
/* harmony default export */ __webpack_exports__["Z"] = (pureFC);


/***/ }),

/***/ 19263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hX": function() { return /* binding */ filter; },
  "UI": function() { return /* binding */ map; },
  "zh": function() { return /* binding */ transduce; }
});

// UNUSED EXPORTS: push

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fn.js
const idX = (argument)=>argument;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
const pipe2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return g(f(...args));
    };
const pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(pipe2) : idX;
};
const mapValues = (mapper)=>(obj)=>Object.assign(...Object.entries(obj).map((param)=>{
            let [key, value] = param;
            return {
                [key]: mapper(value, key, obj)
            };
        }));
const safeCall = (fn, args)=>typeof fn === "function" ? fn(...args) : undefined;
const callIf = (predicate, thenFn, elseFn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return safeCall(predicate(...args) ? thenFn : elseFn, args);
    };
const ifDeff = (value, def)=>value !== undefined ? value : def;

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/transduce.js
/* eslint-disable prettier/prettier */ 
const map = (mapper)=>(reducer)=>(accumulator, item, index, arr)=>reducer(accumulator, mapper(item, index, arr), index, arr);
const filter = (predicate)=>(reducer)=>(accumulator, item, index, arr)=>predicate(item, index, arr) ? reducer(accumulator, item, index, arr) : accumulator;
const push = (list, item)=>{
    list.push(item);
    return list;
};
const transduce = function(list, reducer, initialValue) {
    for(var _len = arguments.length, transducers = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        transducers[_key - 3] = arguments[_key];
    }
    return list.reduce(compose(...transducers)(reducer), initialValue);
};


/***/ }),

/***/ 93745:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.vmap = exports.summ = exports.some = exports.skipIf = exports.resolve = exports.reject = exports.promisify = exports.orderWith = exports.order = exports.mergeProps = exports.mergeAll = exports.merge = exports.mapErrors = exports.isPromise = exports.isLoaded = exports.isFunc = exports.isEmpty = exports.idX = exports.get = exports.every = exports.ensureFunc = exports.compose2 = exports.compose = exports.callWith = exports.callWhenReady = exports.call = exports.asyncAll = exports.asAsync = void 0;
/**
 * Type `Fn<Args extends any[], R>` - Generic Function
 *
 * @template {any[]} A
 * @template R
 * @typedef {(...args: A) => R} Fn
 */ /**
 * Type `Callback<Err extends Error, Res>` - Generic First-Error Callback
 *
 * @template {Error} E
 * @template R
 * @typedef {(error: E, result: R) => void} Callback
 */ /**
 * Type `CompareFn<T>` - Generic Compare Function
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 */ /**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ /**
 * Identiry Function
 *
 * @see https://en.wikipedia.org/wiki/Identity_function
 *
 * @type <T>(x: T) => T
 */ const idX = (x)=>x;
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 *
 * @type {<A extends any[]>(...args: A) => <R>(fn: Fn<A, R>) => R}
 */ exports.idX = idX;
const call = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (fn)=>fn(...args);
};
/**
 * Checks if argument is a Promise or not (actualy if argument is thanable)
 *
 * @type {(value: any) => value is Promise<any>}
 */ exports.call = call;
const isPromise = (value)=>value != null && typeof value.then === "function";
/**
 * Checks if argument is a Function
 *
 * @type {(value: any) => value is Function}
 */ exports.isPromise = isPromise;
const isFunc = (value)=>typeof value === "function";
/**
 * Replaces the first argument with the second one if the the first is not a Function
 *
 * @type {<T>(value: any, def: T) => Function | T}
 */ exports.isFunc = isFunc;
const ensureFunc = (value, def)=>isFunc(value) ? value : def;
/**
 * Composes two function:
 *
 * @example
 * const f = x => x + 1;
 * const g = x => x * 2;
 * const h = compose(f, g);
 * const h_ = x => f(g(x)); // the same as h
 *
 * @type {<A extends any[], R2, R1>(f1: (arg: R2) => R1, f2: (...args: A) => R2) => (...args: A) => R1}
 *
 */ exports.ensureFunc = ensureFunc;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
/**
 * Composes any number of functions.
 * 
 * @type {{
  (): <T>(x: T) => T

  <A extends any[], R>(f: (...args: A) => R): (...args: A) => R;

  <A extends any[], R2, R1>(
    f1: (arg: R2) => R1,
    f2: (...args: A) => R2
  ): (...args: A) => R1;
  
  <A extends any[], R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (...args: A) => R3
  ): (...args: A) => R1;
  
  <A extends any[], R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (...args: A) => R4
  ): (...args: A) => R1;
  
  <A extends any[], R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (...args: A) => R5
  ): (...args: A) => R1;
  
  <A extends any[], R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (...args: A) => R6
  ): (...args: A) => R1;
  
  <A extends any[], R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (...args: A) => R7
  ): (...args: A) => R1;
  
  <A extends any[], R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (...args: A) => R8
  ): (...args: A) => R1;
  
  <A extends any[], R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (...args: A) => R9
  ): (...args: A) => R1;
  
  <A extends any[], RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (arg: RA) => R9,
		fa: (...args: A) => RA;

	<A extends any[], RB, RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
		f9: (arg: RA) => R9,
		fa: (arg: RB) => RA,
    fb: (...args: A) => RB
  ): (...args: A) => R1;
  
  (...fns: Function[]): Function;
}} */ exports.compose2 = compose2;
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
/**
 * Re-throws error mapped with `errorsMapper`.
 *
 * If `errorsMapper` return falsy value the original error will be re-thrown
 *
 * @type {<E1 extends Error, E2 extends Error>(errorsMapper: Fn<[E1], E2 | null | undefined>) => (e: E1) => never}
 */ exports.compose = compose;
const mapErrors = (errorsMapper)=>(err)=>{
        throw errorsMapper(err) || err;
    };
/**
 * Decorator Factory `skipIf` adds effect of replace decorated function (`fn`) call with
 * call of `altFn` if `predicate` returns truthy value.
 *
 * if `altFn` is not specified the [identity](#idX) function will be used
 *
 * @type {<A extends any[], TA>(predicate: Fn<A, boolean>, altFn?: Fn<A, TA>) => <T>(fn: Fn<A, T>) => Fn<A, T | TA>}
 */ exports.mapErrors = mapErrors;
const skipIf = function() {
    let predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ()=>true, altFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : idX;
    return (fn)=>function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return predicate(...args) ? altFn(...args) : fn(...args);
        };
};
/**
 * Checks if value is null or undefined
 *
 * @type {(value: any) => value is null | undefined}
 */ exports.skipIf = skipIf;
const isEmpty = (value)=>value == null;
/**
 * Mergers list of objects to the new one
 *
 * @type <T extends {}>(objects: Array<{}>) => T}
 */ exports.isEmpty = isEmpty;
const mergeAll = (props)=>Object.assign({}, ...props);
/**
 * Merges two or more objects some of those could be an async
 *
 * @type {{
 *  <T>(...props: Array<{}>): T
 *  <T>(...props: Array<{} | Promise<{}>>): Promise<T>
 * }}
 */ exports.mergeAll = mergeAll;
const mergeProps = function() {
    for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
        props[_key] = arguments[_key];
    }
    return props.some(isPromise) ? Promise.all(props).then(mergeAll) : mergeAll(props);
};
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 */ exports.mergeProps = mergeProps;
const callWith = call;
exports.callWith = callWith;
const promiseCallback = (resolve, reject)=>(err, result)=>err ? reject(err) : resolve(result);
/**
 * Converts error-first callbacked async function to function returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Fn<A, Promise<R>>}
 */ const promisify = (fn)=>function promisified() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise((resolve, reject)=>fn.apply(this, args.concat(promiseCallback(resolve, reject))));
    };
/**
 * Calls error-first callbacked async funcation and returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Promise<R>}
 */ exports.promisify = promisify;
const asAsync = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return new Promise((resolve, reject)=>fn(...args, promiseCallback(resolve, reject)));
};
/**
 * Mergers argument objects to the new one
 *
 * @type <T extends {}>(...partials: Array<{}>) => T}
 */ exports.asAsync = asAsync;
const merge = function() {
    for(var _len = arguments.length, partials = new Array(_len), _key = 0; _key < _len; _key++){
        partials[_key] = arguments[_key];
    }
    return Object.assign({}, ...partials);
};
/**
 * Sums two numbers
 *
 * Function created to be used as reducer
 *
 * @type {(a: number, b: number) => number}
 */ exports.merge = merge;
const summ = (a, b)=>a + b;
/**
 * Creates a getter for field or index.
 *
 * @type {{
 * (index: number): <C extends Array<any> | null>(container?: C) => C extends Array<infer T> ? T : C;
 * <N extends string | symbol>(field: N): <C extends { } | null>(container?: C) =>
 *   C extends null | undefined ? C :
 *   C extends { [p in N]?: infer T } ? T :
 *   undefined;
 * }}
 */ exports.summ = summ;
const get = (fieldOrIndex)=>(container)=>container && container[fieldOrIndex];
exports.get = get;
const order2 = (sort1, sort2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return sort1(...args) || sort2(...args);
    };
/**
 * Creates a complex comparing function based on the argument comparing functions
 *
 * @type {<T>(...sorters: CompareFn<T>[]) => CompareFn<T>}
 */ const order = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    return sorters.reduce(order2);
};
/**
 * Basing on argument comparing functions creates a function that sorts an array
 *
 * Function returns a new Array.
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 * @type {<T>(...sorters: CompareFn<T>[]) => <S extends T>(list: S[]) => S[]}
 */ exports.order = order;
const orderWith = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    const compare = order(...sorters);
    return (list)=>list.slice().sort(compare);
};
/**
 * Builds new function from the arguments.
 * New function calls argument-functions and return promise that resolves
 * with array of results returned by correspondent argument function.
 *
 * @type {{
   (): () => Promise<[]>;

  <A extends any[], R1>(f1: Fn<A, R1>): (...args: A) => Promise<[SyncType<R1>]>;

  <A extends any[], R1, R2>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>]>;

  <A extends any[], R1, R2, R3>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>, SyncType<R3>]>;

  <A extends any[], R1, R2, R3, R4>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9, RA>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
    fa: Fn<A, RA>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
    SyncType<RA>,
  ]>;

  <A extends any[], R1>(...fns: Fn<A,R>[]): (...args: A) => Promise<SyncType<R>[]>;
 }}
 */ exports.orderWith = orderWith;
const asyncAll = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.all(fns.map(call(...args)));
    };
};
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for each array item
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.asyncAll = asyncAll;
const every = (predicate)=>(list)=>list.every(predicate);
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for any of array items
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.every = every;
const some = (predicate)=>(list)=>list.some(predicate);
/**
 * Checks if value is not null or undefined
 */ exports.some = some;
const isLoaded = (value)=>value != null;
/**
 * Maps `value` with `mapper`
 * `value` could be an array or an single value.
 *
 * If `value` is an array the vmap returns napped array
 * otherwise vamap returns single mapped value
 *
 * @type {{
 *  <T, S>(mapper: (item: T, list: T[] | null, index: number) => S): <V extends T|T[]>(value: V) => V extends T[] ? S[] : S
 * }}
 */ exports.isLoaded = isLoaded;
const vmap = (mapper)=>(value)=>Array.isArray(value) ? value.map(mapper) : mapper(value, null, 0);
/** Calls fn function when value is resolved.
 * If value is not a promise the fn will be called immediately.
 *
 * @type {<T, R>(fn: (value: T|Promise<T>) => R, value: T | Promise<T>) => V extends Promise<T> ? Promise<R> : R}
 * */ exports.vmap = vmap;
const callWhenReady = (fn, value)=>isPromise(value) ? value.then(fn) : fn(value);
exports.callWhenReady = callWhenReady;
const resolve = (value)=>Promise.resolve(value);
exports.resolve = resolve;
const reject = (error)=>Promise.reject(error);
exports.reject = reject;


/***/ }),

/***/ 38733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = exports.ZP = void 0;
var _ = __webpack_require__(93745);
const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0, _.isPromise)(val) ? val.then(fn) : fn(val), //
    value //
    );
};
__webpack_unused_export__ = pipeA;
pipe.async = pipeA;
var _default = pipe;
exports.ZP = _default;


/***/ }),

/***/ 27639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ shared_utils_memo; },
  "nJ": function() { return /* binding */ memo1; }
});

// UNUSED EXPORTS: memo2, memo3, memoFactory, slice

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/dictionary.js
const Node = ()=>({
        next: new Map()
    });
const add = (root)=>(tokens, value)=>{
        const leaf = tokens.reduce((node, token)=>{
            const subNode = node.next.get(token);
            if (subNode) return subNode;
            const newNode = Node();
            node.next.set(token, newNode);
            return newNode;
        }, root);
        leaf.value = value;
    };
const get = (root)=>(tokens)=>{
        let node = root;
        const l = tokens.length;
        for(let i = 0; node && i < l; i += 1){
            node = node.next.get(tokens[i]);
        }
        return node && node.value;
    };
const DictionaryAPI = (root)=>({
        add: add(root),
        get: get(root)
    });
const Dictionary = ()=>DictionaryAPI(Node());
/* harmony default export */ var dictionary = (Dictionary);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/index.js


/**
 * Creates memoization function
 *
 * @type {(getKey: (args: any[]) => any) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R}
 */ const memoFactory = (getKey)=>(fn)=>{
        // Avoiding memoization on the server-side
        if (false) {}
        const cache = dictionary();
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const key = getKey(args);
            const result = cache.get(key);
            if (result) return result.value;
            const value = fn(...args);
            cache.add(key, {
                value
            });
            return value;
        };
    };
/**
 * Memoize function using all arguments as cache key
 *
 * @type {{
 *   <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 *   n: (n: number) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 * }}
 */ const memo = memoFactory(fn/* idX */.Yr);
/**
 * Creates slicer for list
 *
 * @type {(start: number, end: number) => <T>(list: T[]) => T[]}
 */ const slice = (start, end)=>(list)=>list.slice(start, end);
/**
 * Memoize function using the first one argument as cache key
 */ const memo1 = memoFactory(slice(0, 1));
/**
 * Memoize function using the first two arguments as cache key
 */ const memo2 = memoFactory(slice(0, 2));
/**
 * Memoize function using the first three arguments as cache key
 */ const memo3 = memoFactory(slice(0, 3));
/**
 * Creates memoization function that memoizes using the first `n` arguments as cache key
 */ memo.n = (n)=>memoFactory(slice(0, n));
/* harmony default export */ var shared_utils_memo = (memo);


/***/ }),

/***/ 5098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _insightfulscience_atomic_react_r1_atoms_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50516);
/* harmony import */ var _events_handlers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28763);






function NextLink(param) {
    let { Component =_insightfulscience_atomic_react_r1_atoms_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , href , as , onClick , active , ...props } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const followLink = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>!active ? (0,_events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .handleWith */ .Gy)(onClick, _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, ()=>router.push(href, as)) : _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, [
        href,
        as,
        onClick,
        active
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        ...props,
        href: as || href,
        onClick: followLink
    });
}
NextLink.propTypes = {
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_5__.elementType
    ]),
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    as: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_5__.func,
    active: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
const NextLinkPure = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextLink, {
        ...props,
        Component: "a"
    });
NextLink.Pure = NextLinkPure;
/* harmony default export */ __webpack_exports__["Z"] = (NextLink);


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ composeRefs; },
/* harmony export */   "Gy": function() { return /* binding */ handleWith; },
/* harmony export */   "X$": function() { return /* binding */ prevent; },
/* harmony export */   "aV": function() { return /* binding */ asyncHandleWith; },
/* harmony export */   "k$": function() { return /* binding */ setRef; }
/* harmony export */ });
/* unused harmony export stop */
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10455);
/* harmony import */ var _insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);


const handleWith = function() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
    return (event)=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event));
};
handleWith.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(handleWith);
const asyncHandleWith = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return function() {
        for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
            handlers[_key] = arguments[_key];
        }
        const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
        return (event)=>setTimeout(()=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event)), delay);
    };
};
asyncHandleWith.m = (delay)=>(0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(asyncHandleWith(delay));
const prevent = (event)=>{
    event.preventDefault();
};
const stop = (event)=>{
    event.stopPropagation();
};
const setRef = (ref, value)=>{
    if (ref == null) return;
    if ((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl)(ref)) {
        ref(value);
        return;
    }
    ref.current = value; // eslint-disable-line no-param-reassign
};
const assignRef = (element)=>(ref)=>setRef(ref, element);
const composeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (element)=>refs.forEach(assignRef(element));
};
composeRefs.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(composeRefs);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);